import isEmpty from "lodash/isEmpty";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import { BookingFormMode } from "../booking_form.types";
import css from "./update_bookings_label.module.scss";

type UpdateBookingsLabelProps = {
  mode: BookingFormMode;
  dirtyBookingsIndexes: number[];
};

export const UpdateBookingsLabel = ({ mode, dirtyBookingsIndexes }: UpdateBookingsLabelProps) => {
  const { t } = useTranslation("bookingModule");

  if (mode !== BookingFormMode.EditAll) {
    return null;
  }

  const dirtyBookingsNumbers = dirtyBookingsIndexes.map((index) => index + 1);

  const getLabel = () => {
    if (isEmpty(dirtyBookingsNumbers)) {
      return t("bookings.update.noBookingsChanged");
    }
    if (dirtyBookingsNumbers.length === 1) {
      return t("bookings.update.updateBookingLabel", { bookingNumber: dirtyBookingsNumbers[0] });
    }
    return t("bookings.update.updateBookingsLabel", {
      bookings: dirtyBookingsNumbers.slice(0, -1).join(", "),
      lastBooking: dirtyBookingsNumbers.slice(-1)
    });
  };

  return (
    <Inline justifyContent="end">
      <Typography variant="labelRegular" className={css.label}>
        {getLabel()}
      </Typography>
    </Inline>
  );
};
